import { useIntl } from 'react-intl'

function useExperienceSearchLabels() {
  const intl = useIntl()

  return {
    locationLabel: intl.formatMessage({
      id: '5RJyZ8L4avJ2II7BolkR',
      defaultMessage: 'Destination or experience',
      description: 'Label for experience search location input in the search interface',
    }),
    locationPlaceholder: intl.formatMessage({
      id: 'Ewg3EeQvVW-2sKz-nSk2',
      defaultMessage: 'Search by destination or experience',
      description: 'Placeholder text for experience search location input',
    }),
    searchLabel: intl.formatMessage({
      id: 'mgeoBdt41Hyg_SXlYI9G',
      defaultMessage: 'Search',
      description: 'Button text to submit experience search form in the search interface',
    }),
    whenLabel: intl.formatMessage({
      id: 'eoEjsv0FnQveDShwrthu',
      defaultMessage: 'When',
      description: 'Form field label for the date field when anytime is selected',
    }),
    anytimePlaceholder: intl.formatMessage({
      id: 'RigImioe5lWt2RsFEZL9',
      defaultMessage: 'Anytime',
      description: 'Placeholder for date field indicating any date is acceptable',
    }),
    clearAllLabel: intl.formatMessage({
      id: 'MHb8lQ7Liy1ixnu8EKVa',
      defaultMessage: 'Clear all',
      description: 'Action button label to clear all applied flight filters',
    }),
    todayLabel: intl.formatMessage({
      id: 'AHwE-JrMwGjmJsScIJJ8',
      defaultMessage: 'Today',
      description: 'Quick date chip label for today in experiences date dropdown',
    }),
    tomorrowLabel: intl.formatMessage({
      id: 'IdXFYyn3Ih3xMMiAMWJ1',
      defaultMessage: 'Tomorrow',
      description: 'Quick date chip label for tomorrow in experiences date dropdown',
    }),
    thisWeekendLabel: intl.formatMessage({
      id: 'AzBOEGuHa1-HP1JDqYkD',
      defaultMessage: 'This weekend',
      description: 'Quick date chip label for this weekend in experiences date dropdown',
    }),
    searchInLabel: intl.formatMessage({
      id: 'lipSaV1MLwgF5JI-gKI1',
      defaultMessage: 'Search experiences in',
      description: 'Mobile search bar placeholder text on experiences landing page',
    }),
  }
}

export default useExperienceSearchLabels
